import React from 'react';
import css from './Notifications.module.css';

import {
  Badge,
  Drawer,
  Divider,
  CircularProgress,
  Box,
  Typography,
  Grid,
  Button
} from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import ClearIcon from '@material-ui/icons/Clear';

function Notifications(props) {
  const [open, setOpen] = React.useState(false);
  const numNotis = props.notifications.length;

  const toggleDrawer = (state) => {
    setOpen(state);
  };

  const removeNoti = (id) => () => {
    props.notiActions.remove(id);
  }

  const clearNoti = () => {
    props.notiActions.clear();
  }

  return (
    <React.Fragment>
      <Badge badgeContent={numNotis} color="primary" onClick={() => toggleDrawer(true)}>
        <NotificationsIcon className={css.clear} />
      </Badge>

      <Drawer anchor={'right'} open={open} onClose={() => toggleDrawer(false)}>
        <div className={css.notifications}>
          <div>
            <Button onClick={() => toggleDrawer(false)}>Close</Button>
            <Button className="float-right" onClick={clearNoti}>Clear</Button>
          </div>
          { numNotis === 0 ? <div className={css.noNoti}>No Notifications</div> : null }
          { props.notifications.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <Grid container spacing={3}>
                  <Grid item xs={10}>
                    <div className={css.title}>{item.title}</div>
                    <div className={css.message}>{item.message}</div>
                  </Grid>
                  <Grid container item xs={2} alignContent="center" justifyContent="center">
                  { (item.progress || item.progress === 0) && item.status !== 'done' ?
                    <Box position="relative" display="inline-flex">
                      <CircularProgress variant="determinate" value={item.progress} />
                      <Box
                        top={0}
                        left={0}
                        bottom={0}
                        right={0}
                        position="absolute"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography variant="caption" component="div" color="textSecondary">
                          {`${Math.round(item.progress)}%`}
                        </Typography>
                      </Box>
                    </Box>
                    : null 
                  }
                  { item.status === 'done' ?
                    <ClearIcon className={css.clear} onClick={removeNoti(item.id)} />
                    : null
                  }
                  </Grid>
                  {numNotis > 0 && index !== numNotis - 1 ? <Grid item xs={12}><Divider /></Grid> : null}
                </Grid>
              </React.Fragment>
            )
        })}
        </div>
      </Drawer>
    </React.Fragment>
  );
}

/*
notification = {
  id:
  message: 'string'
  status: false,
  alertDone: false,
  time: new Date(),
  percent: null,
}
*/

Notifications.defaultProps = {
  notifications: []
};

export default Notifications;